import axiosInstance from './axiosInstance'

// ── Types ─────────────────────────────────────────────────────────────────────

export interface Org {
  id:        string
  name:      string
  createdAt: string
}

export interface Lob {
  id:        string
  orgId:     string
  name:      string
  createdAt: string
}

export interface Warehouse {
  id:        string
  orgId:     string
  lobId:     string
  name:      string
  createdAt: string
}

// ── API ───────────────────────────────────────────────────────────────────────

export const orgsApi = {
  getAll: async (): Promise<Org[]> => {
    const res = await axiosInstance.get<{ data: Org[] }>('/admin/orgs')
    return res.data.data
  },
  getById: async (id: string): Promise<Org> => {
    const res = await axiosInstance.get<{ data: Org }>(`/admin/orgs/${id}`)
    return res.data.data
  },
  create: async (name: string): Promise<Org> => {
    const res = await axiosInstance.post<{ data: Org }>('/admin/orgs', { name })
    return res.data.data
  },
  update: async (id: string, name: string): Promise<Org> => {
    const res = await axiosInstance.put<{ data: Org }>(`/admin/orgs/${id}`, { name })
    return res.data.data
  },
  delete: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/admin/orgs/${id}`)
  },
}

export const lobsApi = {
  getAll: async (orgId?: string): Promise<Lob[]> => {
    const res = await axiosInstance.get<{ data: Lob[] }>('/admin/lobs', {
      params: orgId ? { orgId } : undefined,
    })
    return res.data.data
  },
  getById: async (id: string): Promise<Lob> => {
    const res = await axiosInstance.get<{ data: Lob }>(`/admin/lobs/${id}`)
    return res.data.data
  },
  create: async (orgId: string, name: string): Promise<Lob> => {
    const res = await axiosInstance.post<{ data: Lob }>('/admin/lobs', { orgId, name })
    return res.data.data
  },
  update: async (id: string, name: string): Promise<Lob> => {
    const res = await axiosInstance.put<{ data: Lob }>(`/admin/lobs/${id}`, { name })
    return res.data.data
  },
  delete: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/admin/lobs/${id}`)
  },
}

export const warehousesApi = {
  getAll: async (orgId?: string, lobId?: string): Promise<Warehouse[]> => {
    const res = await axiosInstance.get<{ data: Warehouse[] }>('/admin/warehouses', {
      params: { ...(orgId && { orgId }), ...(lobId && { lobId }) },
    })
    return res.data.data
  },
  getById: async (id: string): Promise<Warehouse> => {
    const res = await axiosInstance.get<{ data: Warehouse }>(`/admin/warehouses/${id}`)
    return res.data.data
  },
  create: async (orgId: string, lobId: string, name: string): Promise<Warehouse> => {
    const res = await axiosInstance.post<{ data: Warehouse }>('/admin/warehouses', { orgId, lobId, name })
    return res.data.data
  },
  update: async (id: string, name: string): Promise<Warehouse> => {
    const res = await axiosInstance.put<{ data: Warehouse }>(`/admin/warehouses/${id}`, { name })
    return res.data.data
  },
  delete: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/admin/warehouses/${id}`)
  },
}
